<section class="global-search" [class.is-active]="true">
  <div class="global-search__container">
    <div class="container">
      <div class="global-search__form">
        <input
          id="global-search-input"
          type="text"
          placeholder="I am searching for"
          autocomplete="off"
          #searchInput
          [(ngModel)]="searchText"
        />
        @if (searchText) {
          <button
            id="btn-global-search-clear"
            class="btn-close"
            (click)="clearSearch()"
          >
            <i class="fal fa-times"></i>
          </button>
        }
        <button
          id="btn-global-search-submit"
          class="btn-search"
          (click)="search()"
        >
          <i class="far fa-search"></i>
        </button>
      </div>
    </div>
  </div>
</section>

@if (showBackdrop) {
  <div
    class="global-search__cover"
    [class.is-active]="true"
    (click)="close()"
  ></div>
}
